function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-233.49945)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect4627-3-7",
  d: "m 34.733604,254.59837 a 1.3636621,1.5796701 0 0 0 -1.363879,1.57988 v 17.94174 a 1.3636621,1.5796701 0 0 0 1.363879,1.57991 h 15.103317 a 1.3636621,1.5796701 0 0 0 1.363876,-1.57991 v -17.94174 a 1.3636621,1.5796701 0 0 0 -1.363876,-1.57988 z m 1.363877,3.15982 h 12.378076 v 14.78189 H 36.097481 Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g4715-2-2-6-6-4-3",
  transform: "matrix(-0.32018578,0,0,-0.36298855,3.0603637,349.28478)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect4708-9-7-1-1-4-5",
  width: 13.896279,
  height: 12.37512,
  x: -50.178444,
  y: 224.95557
}), /*#__PURE__*/React.createElement("path", {
  d: "m -35.011866,228.04803 7.750719,1.46996 0.133633,3.47041 -7.884352,1.33633 z",
  id: "rect4710-1-0-8-5-3-6"
})), /*#__PURE__*/React.createElement("g", {
  id: "g4715-2-2-6-6-4-2",
  transform: "matrix(-0.32018578,0,0,-0.36298855,3.1012409,370.19084)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect4708-9-7-1-1-4-9",
  width: 13.896279,
  height: 12.37512,
  x: -50.178444,
  y: 224.95557
}), /*#__PURE__*/React.createElement("path", {
  d: "m -35.011866,228.04803 7.750719,1.46996 0.133633,3.47041 -7.884352,1.33633 z",
  id: "rect4710-1-0-8-5-3-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "g4715-2-2-6-6-4-3-3",
  transform: "matrix(0.32018578,0,0,-0.36298855,81.155725,349.44209)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect4708-9-7-1-1-4-5-6",
  width: 13.896279,
  height: 12.37512,
  x: -50.178444,
  y: 224.95557
}), /*#__PURE__*/React.createElement("path", {
  d: "m -35.011866,228.04803 7.750719,1.46996 0.133633,3.47041 -7.884352,1.33633 z",
  id: "rect4710-1-0-8-5-3-6-0"
})), /*#__PURE__*/React.createElement("g", {
  id: "g4715-2-2-6-6-4-2-6",
  transform: "matrix(0.32018578,0,0,-0.36298855,81.114848,370.34815)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect4708-9-7-1-1-4-9-2",
  width: 13.896279,
  height: 12.37512,
  x: -50.178444,
  y: 224.95557
}), /*#__PURE__*/React.createElement("path", {
  d: "m -35.011866,228.04803 7.750719,1.46996 0.133633,3.47041 -7.884352,1.33633 z",
  id: "rect4710-1-0-8-5-3-1-6"
})), /*#__PURE__*/React.createElement("path", {
  id: "rect2001",
  d: "m 23.453125,235.45703 a 3.2583612,3.2583612 0 0 0 -3.257813,3.25781 v 52.9668 a 3.2583612,3.2583612 0 0 0 3.257813,3.25781 h 37.154297 a 3.2583612,3.2583612 0 0 0 3.257812,-3.25781 v -52.9668 a 3.2583612,3.2583612 0 0 0 -3.257812,-3.25781 z m 3.257813,6.51563 h 30.638671 v 46.45117 H 26.710938 Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "text3049",
  "aria-label": 2
}, /*#__PURE__*/React.createElement("path", {
  id: "path3053",
  d: "m 47.631131,263.547 q 0,0.46566 -0.201081,0.81491 -0.190497,0.33866 -0.772573,0.91015 -0.582076,0.56091 -2.158973,1.91556 h 2.127223 q 0.04233,-0.57149 0.52916,-0.57149 0.52916,0 0.52916,0.69849 v 0.93132 h -4.804773 v -1.11123 q 0.201081,-0.16934 0.719658,-0.59266 0.52916,-0.42333 0.76199,-0.62441 0.243414,-0.20108 0.666742,-0.56091 0.423328,-0.37041 0.634992,-0.58208 0.211664,-0.21166 0.455077,-0.47624 0.253997,-0.26458 0.349246,-0.45508 0.105832,-0.1905 0.105832,-0.33866 0,-0.40216 -0.349246,-0.67733 -0.349245,-0.27516 -0.867822,-0.27516 -0.391578,0 -0.656158,0.127 -0.253997,0.127 -0.359829,0.30691 -0.105832,0.17991 -0.190498,0.35983 -0.07408,0.17991 -0.201081,0.30691 -0.126998,0.127 -0.328079,0.127 -0.211664,0 -0.370412,-0.14816 -0.158748,-0.15875 -0.158748,-0.35983 0,-0.61383 0.656158,-1.1959 0.666742,-0.58208 1.629813,-0.58208 0.963072,0 1.608647,0.59266 0.645575,0.58207 0.645575,1.46048 z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-21.1664)",
  id: "layer5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 39.190856,49.43583 q 1.121819,0 1.703895,0.85724 0.592659,0.85724 0.592659,2.09547 v 1.00541 q 0,0.79374 -0.243413,1.44989 -0.232831,0.64558 -0.772574,1.07949 -0.52916,0.42333 -1.280567,0.42333 -1.121819,0 -1.714479,-0.85724 -0.582076,-0.85724 -0.582076,-2.09547 v -1.00541 q 0,-0.79374 0.232831,-1.43931 0.243413,-0.65616 0.772573,-1.07949 0.539744,-0.43391 1.291151,-0.43391 z m -1.238235,2.87863 v 1.15357 q 0,0.82549 0.338663,1.3229 0.338662,0.49741 0.899572,0.49741 0.560909,0 0.899572,-0.49741 0.338662,-0.49741 0.338662,-1.3229 v -1.15357 q 0,-0.82549 -0.338662,-1.3229 -0.338663,-0.49741 -0.899572,-0.49741 -0.56091,0 -0.899572,0.49741 -0.338663,0.49741 -0.338663,1.3229 z",
  id: "path945"
}));

var SvgMapApe02 = function SvgMapApe02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 84.6656 63.4992",
    height: 240,
    width: 320,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapApe02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-ape02.7ff48a97.svg";
export { ForwardRef as ReactComponent };